const ADDRESS_CATEGORIES = ["All", "District", "Mukim", "Village"] as const;

const CITIZENSHIP_OPTIONS = [
  "Brunei Darussalam",
  "Permanent Resident",
  "Foreigner",
] as const;

const FILE_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "application/pdf",
] as const;

const FULFILLMENT_TYPES = [
  {
    label: "instant-delivery",
    value: "Instant Delivery",
    requireLogin: true,
  },
  {
    label: "delivery",
    value: "Delivery",
    requireLogin: false,
  },
  {
    label: "pick-up",
    value: "Pick Up",
    requireLogin: false,
  },
] as const;

const SALUTATION_OPTIONS = ["Mr", "Ms"] as const;

const SERVICES = [
  {
    label: "Infinity",
    planType: "Infinity",
    icon: "/images/infinity.webp",
    href: "/infinity",
    customerType: "RES",
    requireLogin: false,
  },
  {
    label: "Mobi",
    planType: "Mobi",
    icon: "/images/mobi.webp",
    href: "/mobi",
    customerType: "MOBI-POSTPAID",
    requireLogin: false,
  },
  {
    label: "Freedom",
    planType: "Freedom",
    icon: "/images/freedom.webp",
    href: "/freedom",
    customerType: "FREEDOM",
    requireLogin: false,
  },
  {
    label: "EASI",
    planType: "EASI",
    icon: "/images/easi.webp",
    href: "/easi",
    customerType: "MOBI-PREPAID",
    requireLogin: false,
  },
  {
    label: "EASI Recaj",
    icon: "/images/easi-recharge.webp",
    href: "/easi-recharge/select-package",
    customerType: "EASI-RECHARGE",
    requireLogin: true,
  },
  {
    label: "EASI Tourist",
    planType: "EASI",
    icon: "/images/easi-tourist.webp",
    href: "/tourist",
    customerType: "TOURIST",
    requireLogin: false,
  },
  {
    label: "Mobi 5G",
    planType: "Mobi",
    icon: "/images/mobi-5g.webp",
    href: "/mobi-5g",
    customerType: "MOBI-POSTPAID",
    requireLogin: true,
  },
  {
    label: "Freedom 5G",
    planType: "Freedom",
    icon: "/images/freedom-5g.webp",
    href: "/freedom-5g",
    customerType: "FREEDOM",
    requireLogin: true,
  },
] as const;

const SOCIAL_MEDIA_LINKS = [
  {
    label: "Facebook",
    url: "https://www.facebook.com/dstbn",
    icon: "/images/facebook.webp",
  },
  {
    label: "Instagram",
    url: "https://www.instagram.com/dstbn",
    icon: "/images/instagram.webp",
  },
  {
    label: "Youtube",
    url: "https://www.youtube.com/channel/UC2Xxy9aRjJBn4_UwmQV_eQw",
    icon: "/images/youtube.webp",
  },
] as const;

export {
  ADDRESS_CATEGORIES,
  CITIZENSHIP_OPTIONS,
  FILE_TYPES,
  FULFILLMENT_TYPES,
  SALUTATION_OPTIONS,
  SERVICES,
  SOCIAL_MEDIA_LINKS,
};
